const FleetTechnicalSupportContactInfo = {
    Phone: '866-472-6711',
    Email: 'fleet.helpdesk@gsa.gov'
}

export default FleetTechnicalSupportContactInfo;